import { useState } from 'react';

import Button from '@/components/shared/Button/Button';
import Popup from '@/components/shared/Popup/Popup';
import { POPUPS } from '@/js/AppState';
import clsx from 'clsx';
import { FaArrowLeft, FaArrowRight, FaXmark } from 'react-icons/fa6';
import PopupsManager from 'react-sdk/PopupsManager';
import classes from './PopupRecommandations.module.css';


const PopupRecommandations = () => {

  const image = PopupsManager.getData(POPUPS.RECOMMANDATIONS)


  function handleClose() {
    PopupsManager.close(POPUPS.RECOMMANDATIONS)
  }

  return (
    <Popup className={classes.PopupRecommandations}>
      <div className={classes.content_scroll_cntr}>
        <div className={classes.content}>
          <div className={classes.image}>
            <img src={image} alt="" />
          </div>
        </div>
      </div>
      <Button className={classes.close} icon={<FaXmark />} onClick={handleClose} />
    </Popup>
  );
};

export default PopupRecommandations;
